var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.error)?_c('div',{staticClass:"bg-light px-4 py-6 text-center"},[_c('img',{attrs:{"src":require("@/assets/icons/marker.svg"),"height":"25"}}),_vm._v(" "+_vm._s(_vm.error)+" ")]):_c('div',{ref:"map",staticStyle:{"height":"240px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }